import {useContext} from 'react';
import {ValidationContext} from '../pages/components/formContext/FormContext';

export const useRequiredFields = (name) => {
    const {requiredFields} = useContext(ValidationContext);
    return requiredFields?requiredFields[name]:false;
};
